import { API_BASE_URL, isChatApiConfigured } from '../config';

/**
 * Send a message to the chat API
 */
export const sendChatMessage = async (
  id: string | undefined, 
  messages: string[], 
  senderId: string
): Promise<string> => {
  if (!isChatApiConfigured) {
    throw new Error('CHAT_API_NOT_CONFIGURED');
  }

  const response = await fetch(`${API_BASE_URL}chat/web/${id}`, {
    method: 'POST',
    mode: 'cors',
    headers: {
      'Content-Type': 'application/json',
      'senderId': senderId
    },
    body: JSON.stringify(messages)
  });

  if (!response.ok) {
    const errorText = await response.text();
    
    // Check for content filter
    if (errorText.includes('content_filter') || errorText.includes('content management policy')) {
      throw new Error('CONTENT_FILTER_ERROR');
    }
    
    throw new Error(`Network response was not ok: ${response.status}`);
  }

  const botResponse = await response.text();
  // Clean and decode the response
  return JSON.parse(`"${botResponse.replace(/^"|"$/g, '').replace(/"/g, '\\"')}"`);
};
